var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmallArchPurple = function SvgSmallArchPurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.957,
    height: 16.326
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15846",
    d: "M21.978 4.802a18.183 18.183 0 0 1 16.9 11.523h5.079a22.957 22.957 0 0 0-43.957 0h5.079a18.183 18.183 0 0 1 16.9-11.523",
    fill: "#656dfd"
  })));
};
export { SvgSmallArchPurple as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0My45NTciIGhlaWdodD0iMTYuMzI2IiB2aWV3Qm94PSIwIDAgNDMuOTU3IDE2LjMyNiI+CiAgPHBhdGggaWQ9IlBhdGhfMTU4NDYiIGRhdGEtbmFtZT0iUGF0aCAxNTg0NiIgZD0iTTMzMDMuODU3LDQ2MDQuMDI1YTE4LjE4MywxOC4xODMsMCwwLDEsMTYuOSwxMS41MjNoNS4wNzlhMjIuOTU3LDIyLjk1NywwLDAsMC00My45NTcsMGg1LjA3OWExOC4xODMsMTguMTgzLDAsMCwxLDE2LjktMTEuNTIzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzI4MS44NzkgLTQ1OTkuMjIzKSIgZmlsbD0iIzY1NmRmZCIvPgo8L3N2Zz4K";